import { Vector4, Color as Linear } from "three";
import { color } from "d3";

const LIGHT_LUMINANCE_THRESHOLD = 220;
const DARK_LUMINANCE_THRESHOLD = 50;

class Color {
  constructor(hex) {
    this.color = color(hex);
    this.r = this.color.r / 255;
    this.g = this.color.g / 255;
    this.b = this.color.b / 255;
    this.a = this.color.opacity;
  }

  get hex() {
    const chroma = this.normalize();
    return chroma.color.formatHex8();
  }

  get vec() {
    const chroma = this.normalize();
    const sr = new Linear(chroma.r, chroma.g, chroma.b, chroma.a);
    return new Vector4(sr.r, sr.g, sr.b, chroma.a);
  }

  get luminance() {
    const r = this.color.r ** 2;
    const g = this.color.g ** 2;
    const b = this.color.b ** 2;
    return Math.sqrt(0.299 * r + 0.587 * g + 0.114 * b);
  }

  clone() {
    return new Color(this.color.formatHex8());
  }

  normalize() {
    if (this.color.displayable()) {
      return this;
    }
    this.color = this.color.clamp();
    return this.clone();
  }

  fixLuminanceUpper(threshold) {
    while (this.luminance > threshold) {
      this.color = this.color.darker(1);
    }
  }

  fixLuminanceLower(threshold) {
    while (this.luminance < threshold) {
      this.color = this.color.brighter(1);
    }
  }

  brighten(val) {
    if (val > 0) this.color = this.color.brighter(val);
    if (val < 0) this.color = this.color.darker(-val);
    return this.clone();
  }

  fixLuminance(theme) {
    const isLight = theme === 1;
    const isDark = theme === 2;

    while (isDark && this.luminance < DARK_LUMINANCE_THRESHOLD) {
      this.color = this.color.brighter(1);
    }

    while (isLight && this.luminance > LIGHT_LUMINANCE_THRESHOLD) {
      this.color = this.color.darker(1);
    }

    return this.clone();
  }

  setOpacity(opacity) {
    this.color = this.color.copy({ opacity });
    return this.clone();
  }
}

export default Color;
